import { Injectable } from '@angular/core';
import { WindowReferenceService } from './window-reference.service';


@Injectable({
    providedIn: 'root'
})
export class DataLayerService {
   private window; 

   constructor (private _windowRef: WindowReferenceService)
   {
       this.window = _windowRef.nativeWindow; // intialise the window to what we get from our window service
       this.pushDataLayerObject({
        event: 'pageLoad'
       });
   }

    private pushDataLayerObject(obj: object): void
    {
        this.window.dataLayer = this.window.dataLayer || [];
        if(obj) this.window.dataLayer.push(obj);
    }


   //list of all our dataLayer methods

   logPageView(payload: { page_path: string; page_location: string; page_title: string }): void
   {
       this.pushDataLayerObject({
           event: 'page_view',
           ...payload
       });
   }

   logEvent(event,category = null,action = null,label = null)
   {
       const hit = {
           event:event,
           ...(category ? { category } : null),
           ...(action ? { action } : null),
           ...(label ? { label } : null)
       }
        this.pushDataLayerObject(hit);
   }

   logCustomDimensionTest(value)
   {
       const hit = {
           event:'custom-dimension',
           value:value
       }
       this.pushDataLayerObject(hit);
   }

   logConversion(value: number = 1.0, transactionId: string = '')
   {
       if (typeof this.window.gtag === 'function') {
           this.window.gtag('event', 'conversion', {
               'send_to': 'AW-743304540/5A_hCOH04bscENzat-IC',
               'value': value,
               'currency': 'ARS',
               'transaction_id': transactionId
           });
       }
   }

   // .. add more custom methods as needed by your app.
}